/**
 * @file page
 * @author v_lichaoqing
 */

import {GET_CMSAPI_GETARTICLEDATA} from '../actions/ActionTypes';

export function cmsapiGetArticleData(state = {}, action) {
    switch (action.type) {
        case GET_CMSAPI_GETARTICLEDATA:
            if (action.data.is_error === 0) {
                state = action.data;
                return state;
            }
            return {};
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/page.js